(() => {
  angular
    .module('app.settings')
    .controller('DcmConfirmDeactivateModalController', DcmConfirmDeactivateModal);

  DcmConfirmDeactivateModal.$inject = [
    'close',
    'deactivate',
    'integration',
  ];

  function DcmConfirmDeactivateModal(
    close,
    deactivate,
    integration,
  ) {
    const vm = this;

    vm.deactivate = () => {
      vm.isProcessBusy = true;
      deactivate(integration)
        .then(response => {
          vm.isProcessBusy = true;
          close(response, 500);
        });
    };

    vm.close = () => close(false, 0);
  }
})();
